"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7960],{

/***/ 48867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28165);
/* harmony import */ var _Th__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45922);



var Head = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("thead",  true ? {
  target: "eif33nw0"
} : 0)("z-index:1;", function (_ref) {
  var _ref$sticky = _ref.sticky,
      sticky = _ref$sticky === void 0 ? true : _ref$sticky,
      top = _ref.top;
  return sticky &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)("z-index:3;position:sticky;top:", top, "px;" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref2) {
  var sticky = _ref2.sticky,
      shadow = _ref2.shadow,
      theme = _ref2.theme;
  return sticky && shadow &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)("box-shadow:", theme.shadows[1], ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", _Th__WEBPACK_IMPORTED_MODULE_1__.Th, "{background-color:", function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, ";}", function (_ref4) {
  var zebra = _ref4.zebra,
      zebraBackgroundColor = _ref4.zebraBackgroundColor;
  return zebra &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_Th__WEBPACK_IMPORTED_MODULE_1__.Th, "{background-color:", zebraBackgroundColor, ";}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));

/***/ }),

/***/ 82534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ cellBasic; },
/* harmony export */   "Td": function() { return /* binding */ Td; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var cellBasic =  true ? {
  name: "k4nyhq",
  styles: "background-clip:padding-box;padding:12px 16px;max-width:max(255px, 45%);min-width:150px"
} : 0;
var Td = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("td",  true ? {
  target: "e1by0wqo0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.typography.textRegularSmall;
}, ";", cellBasic, " text-align:", function (_ref2) {
  var align = _ref2.align;
  return align;
}, ";vertical-align:", function (_ref3) {
  var vAlign = _ref3.vAlign;
  return vAlign;
}, ";", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("sm");
}, "{", function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.pSmall;
}, ";min-width:160px;}" + ( true ? "" : 0));

/***/ }),

/***/ 45922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Th": function() { return /* reexport */ Th; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TableBasic/Td/Td.tsx
var Td = __webpack_require__(82534);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableBasic/Th/Th.tsx


var Th = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("th",  true ? {
  target: "e1488we50"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.typography.textBoldSmall;
}, ";", Td/* cellBasic */.N, " background-color:inherit;text-align:left;text-align:", function (_ref2) {
  var align = _ref2.align;
  return align;
}, ";vertical-align:", function (_ref3) {
  var vAlign = _ref3.vAlign;
  return vAlign;
}, ";", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("sm");
}, "{", function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.h6;
}, ";min-width:160px;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableBasic/Th/index.ts


/***/ }),

/***/ 74553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Tr": function() { return /* reexport */ Tr_Tr; },
  "w": function() { return /* reexport */ Tr; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TableBasic/Th/index.ts + 1 modules
var Th = __webpack_require__(45922);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableBasic/Tr/Tr.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




var _ref =  true ? {
  name: "4qnjel",
  styles: ":after{position:absolute;content:'';top:0;bottom:0;width:100px;right:0;-webkit-clip-path:inset(0 -100% 0 0);box-shadow:13px 7px 30px -4px rgba(13, 21, 55, 0.05);pointer-events:none;}"
} : 0;

var Tr = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("tr",  true ? {
  target: "eezlur80"
} : 0)("background-color:", function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
}, ";", function (_ref3) {
  var _ref3$sticky = _ref3.sticky,
      sticky = _ref3$sticky === void 0 ? true : _ref3$sticky,
      shadow = _ref3.shadow,
      pinZIndex = _ref3.pinZIndex;
  return sticky &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)(Th.Th, ":first-child{position:sticky;left:0;z-index:", pinZIndex, ";", shadow && _ref, ";}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableBasic/Tr/Tr.tsx


var _excluded = ["tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseTr = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tr, _objectSpread(_objectSpread({
    ref: ref
  }, tokens), rest));
});
var Tr_Tr = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTr, function (_, theme) {
  return {
    backgroundColor: theme.palette.neutrals.white[100],
    pinZIndex: 1
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableBasic/Tr/index.ts



/***/ }),

/***/ 87960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* reexport */ Body_Body; },
  "Fb": function() { return /* reexport */ Head; },
  "Td": function() { return /* reexport */ Td.Td; },
  "Th": function() { return /* reexport */ Th.Th; },
  "Tr": function() { return /* reexport */ Tr.Tr; },
  "ZP": function() { return /* reexport */ TableBasic; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TableBasic/Head/Head.views.tsx
var Head_views = __webpack_require__(48867);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TableBasic/Tr/index.ts + 2 modules
var Tr = __webpack_require__(74553);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableBasic/TableBasic.views.ts





var TableContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1l476et2"
} : 0)("border-radius:4px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";width:100%;max-width:1280px;overflow-x:auto;", function (_ref2) {
  var theme = _ref2.theme,
      scrollable = _ref2.scrollable;
  return !scrollable &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)(theme.breakpoints.up("xxl"), "{overflow:initial;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref3) {
  var theme = _ref3.theme,
      scrollable = _ref3.scrollable;
  return scrollable &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("overflow:auto;max-height:60vh;", theme.breakpoints.up("sm"), "{max-height:80vh;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var TableWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1l476et1"
} : 0)("width:100%;", function (_ref4) {
  var borders = _ref4.borders,
      borderColor = _ref4.borderColor;
  return borders === "all" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("border-top:1px solid;border-left:1px solid;border-color:", borderColor, ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref5) {
  var snapping = _ref5.snapping;
  return snapping &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("scroll-snap-type:both proximity;", Td.Td, ",", Th.Th, "{scroll-snap-align:start;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var StyledTable = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("table",  true ? {
  target: "e1l476et0"
} : 0)("border-collapse:separate;border-spacing:0;color:", function (_ref6) {
  var color = _ref6.color;
  return color;
}, ";", function (_ref7) {
  var fixedLayout = _ref7.fixedLayout;
  return fixedLayout && "table-layout: fixed;";
}, " ", function (_ref8) {
  var borders = _ref8.borders,
      borderColor = _ref8.borderColor;
  return borders === "all" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)(Td.Td, ",", Th.Th, "{border-bottom:1px solid;border-right:1px solid;border-color:", borderColor, ";}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref9) {
  var borders = _ref9.borders,
      borderColor = _ref9.borderColor;
  return borders === "vertical" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)(Head_views/* Head */.F, " ", Th.Th, "{border-right:1px solid;border-color:", borderColor, ";&:last-of-type{border:none;}}", Tr/* TrView */.w, " ", Td.Td, "{border:none;}", Tr/* TrView */.w, " ", Td.Td, ",", Tr/* TrView */.w, " ", Th.Th, "~", Td.Td, ",{border-right:1px solid;border-color:", borderColor, ";&:last-of-type{border:none;}}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableBasic/TableBasic.tsx


var _excluded = ["children", "borders", "scrollable", "snapping", "fixedLayout", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseTableBasic = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$borders = _ref.borders,
      borders = _ref$borders === void 0 ? "vertical" : _ref$borders,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? true : _ref$scrollable,
      _ref$snapping = _ref.snapping,
      snapping = _ref$snapping === void 0 ? false : _ref$snapping,
      _ref$fixedLayout = _ref.fixedLayout,
      fixedLayout = _ref$fixedLayout === void 0 ? false : _ref$fixedLayout,
      tokens = _ref.tokens,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableContainer, _objectSpread(_objectSpread({
    scrollable: scrollable,
    tabIndex: 0
  }, tokens), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableWrapper, _objectSpread(_objectSpread({
      snapping: snapping,
      borders: borders
    }, tokens), {}, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTable, _objectSpread(_objectSpread(_objectSpread({
        borders: borders,
        fixedLayout: fixedLayout
      }, tokens), props), {}, {
        ref: ref,
        children: children
      }))
    }))
  }));
});
var TableBasic = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTableBasic, function (_, theme) {
  return {
    backgroundColor: theme.palette.neutrals.white[100]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700],
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[700],
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100],
      borderColor: theme.palette.twilio.gray[30]
    };
  }
});
// EXTERNAL MODULE: ../../libs/matcha/recipes/TableBasic/Td/Td.tsx
var Td = __webpack_require__(82534);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableBasic/Td/index.ts

// EXTERNAL MODULE: ../../libs/matcha/recipes/TableBasic/Th/index.ts + 1 modules
var Th = __webpack_require__(45922);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableBasic/Head/Head.tsx


var Head_excluded = ["sticky", "shadow", "pinFirst", "zebra", "children", "tokens"];

function Head_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Head_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Head_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Head_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseHead = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var sticky = _ref.sticky,
      shadow = _ref.shadow,
      pinFirst = _ref.pinFirst,
      zebra = _ref.zebra,
      children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Head_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Head_views/* Head */.F, Head_objectSpread(Head_objectSpread(Head_objectSpread({
    sticky: sticky,
    shadow: shadow,
    pinFirst: pinFirst,
    zebra: zebra,
    ref: ref
  }, tokens), rest), {}, {
    children: children
  }));
});
var Head = (0,useDesignTokens/* withDesignTokens */.Y)(BaseHead, function (_, theme) {
  return {
    backgroundColor: theme.palette.neutrals.white[100],
    top: 0
  };
}, {
  light: function light(theme) {
    return {
      zebraBackgroundColor: theme.palette.brand.darkAcai[100]
    };
  },
  dark: function dark(theme) {
    return {
      zebraBackgroundColor: theme.palette.brand.darkAcai[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      zebraBackgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableBasic/Head/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableBasic/Body/Body.views.ts




var Body = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("tbody",  true ? {
  target: "e1cepxgf0"
} : 0)(function (_ref) {
  var zebra = _ref.zebra,
      zebraBackgroundColor = _ref.zebraBackgroundColor;
  return zebra &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)(Tr/* TrView */.w, "{:nth-of-type(", zebra, "){background-color:", zebraBackgroundColor, ";", Th.Th, "{background-color:", zebraBackgroundColor, ";}}}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableBasic/Body/Body.tsx


var Body_excluded = ["zebra", "children", "tokens"];

function Body_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Body_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Body_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Body_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseBody = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$zebra = _ref.zebra,
      zebra = _ref$zebra === void 0 ? "even" : _ref$zebra,
      children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Body_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, Body_objectSpread(Body_objectSpread(Body_objectSpread({
    zebra: zebra,
    ref: ref
  }, tokens), rest), {}, {
    children: children
  }));
});
var Body_Body = (0,useDesignTokens/* withDesignTokens */.Y)(BaseBody, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      zebraBackgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      zebraBackgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      zebraBackgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableBasic/Body/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableBasic/index.ts






Tr.Tr.displayName = "Table.Tr";
Td.Td.displayName = "Table.Td";
Th.Th.displayName = "Table.Th";
Head.displayName = "Table.Head";
Body_Body.displayName = "Table.Body";


/***/ })

}]);